import React from "react";
import styles from "./DossierDashboard.module.scss";

const SEG_CLASSES = {
  1: styles.segDraft,
  2: styles.segValidated,
  3: styles.segFinalized,
};

const StatusProgress = ({ stats, activeStatus, onToggleStatus }) => {
  if (stats.count === 0) return null;
  return (
    <div className={styles.sect}>
      <div className={styles.sectTitle}>
        <span>Avancement</span>
        <span className={styles.sectTitleRight}>
          {stats.contractsRemaining} contrat
          {stats.contractsRemaining > 1 ? "s" : ""} restant à générer
        </span>
      </div>
      <div className={styles.progressBar}>
        {stats.statuses.map((s) => (
          <button
            key={s.id}
            type="button"
            className={`${styles.progressSeg} ${SEG_CLASSES[s.id] || ""} ${
              activeStatus === String(s.id) ? styles.segActive : ""
            }`}
            style={{ width: (s.count / stats.count) * 100 + "%" }}
            onClick={() => onToggleStatus(s.id)}
            title={`${s.count} ${s.name} — filtrer la liste`}
          >
            {s.count} {s.name}
            {s.count > 1 ? "s" : ""}
          </button>
        ))}
      </div>
      <div className={styles.note}>
        clic sur un segment → filtre la liste par statut
      </div>
    </div>
  );
};

export default StatusProgress;
